import classnames from 'classnames';
import React from 'react';

import cs from 'app/components/Sidebar/styles.module.scss';

export interface SidebarPanelProps {
  /** Fixed at the top, above the toolbar. */
  header?: React.ReactNode;
  /** Fixed between the header and the scrolling body. */
  toolbar?: React.ReactNode;
  /** Pinned to the bottom, over the body. */
  actionBar?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  /**
   * Tinted for a panel whose content is cards sitting on the background; white
   * for one that reads as a single surface.
   */
  bodyBackground?: 'white' | 'offWhite';
  /** The scrolling element, for callers that need to scroll it themselves. */
  bodyRef?: React.RefObject<HTMLDivElement>;
}

/**
 * Shell for a sidebar tab: fixed white bars around a scrolling body. Only the
 * body scrolls, so a toolbar or action bar stays reachable however long the
 * content gets.
 */
export const SidebarPanel: React.FC<React.PropsWithChildren<SidebarPanelProps>> = ({
  header,
  toolbar,
  actionBar,
  className,
  bodyClassName,
  bodyBackground = 'white',
  bodyRef,
  children,
}) => (
  <div className={classnames(cs.panel, className)}>
    {(header || toolbar) && (
      <div className={classnames(cs.panelBar, cs.panelBarTop)}>
        {header}
        {toolbar}
      </div>
    )}
    <div
      ref={bodyRef}
      className={classnames(
        cs.panelBody,
        bodyBackground === 'offWhite' ? cs.panelBodyOffWhite : cs.panelBodyWhite,
        bodyClassName
      )}
    >
      {children}
    </div>
    {actionBar && <div className={classnames(cs.panelBar, cs.panelBarBottom)}>{actionBar}</div>}
  </div>
);
